module.exports = __webpack_public_path__ + "static/media/location-pin-alt.7415a2c8.svg";